
export const BUTTON_PRESETS = {
  sample: {
    variant: "contained" as const,
    size: "medium" as const,
    color: "primary" as const,
    children: "Sample Button",
  },
  copyToClipboard: {
    variant: "outlined" as const,
    size: "large" as const,
    color: "primary" as const,
    customColor: "var(--primary-main, #155DFC)",
    children: "Copy to Clipboard",
  },
  addRow: {
    variant: "text" as const,
    size: "small" as const,
    color: "primary" as const,
    customColor: "var(--primary-main, #155DFC)",
    children: "+ Add Row",
  },
} as const;
